import { render, staticRenderFns } from "./GoogleBusinessIcon.vue?vue&type=template&id=f87e1ae8&scoped=true"
var script = {}
import style0 from "./GoogleBusinessIcon.vue?vue&type=style&index=0&id=f87e1ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87e1ae8",
  null
  
)

export default component.exports